module.exports = __webpack_public_path__ + "static/media/DK_Layout_5.d270cd91.png";